import {connect} from 'react-redux';
import LandingPageComponent from '../../Components/LandPage';
import {userLogin} from '../../redux/actions/AuthActions';
import {withRouter} from 'react-router';

const LandingContainer = connect (
    (state) => {
        return {
            isAuthenticated: state.authReducer.isAuthenticated,
            userRoles: state.authReducer.info.userRoles
        };
    },
    (dispatch) => {
        return {
            userLogin: (email,password) => {
                dispatch(userLogin(email,password));
            }
        };
    }
)(LandingPageComponent);

export default withRouter(LandingContainer);